export default __webpack_public_path__ + "static/media/closer-flowerchick.04a69ed4.mp3";